import Vue from 'vue'
import App from './App.vue'
import './assets/reset.css'
import './assets/main.css'
import router from './router'
import store from './store'
import animated from 'animate.css'
import ElementUI from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import global from './Common.vue'
Vue.prototype.COMMON = global



// 省略部分代码
Vue.use(animated)
Vue.use(ElementUI);
// Vue.prototype.$axios = axios
axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.baseURL = 'http://119.23.227.216:8088/';



router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title + "——伟骞泉鉴网"
  }
  next()
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
